import { render, staticRenderFns } from "./LastEvents.vue?vue&type=template&id=01d51001&scoped=true&"
import script from "./LastEvents.vue?vue&type=script&lang=js&"
export * from "./LastEvents.vue?vue&type=script&lang=js&"
import style0 from "./LastEvents.vue?vue&type=style&index=0&id=01d51001&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d51001",
  null
  
)

/* custom blocks */
import block0 from "./LastEvents.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports